import { usePopup } from 'hooks/usePopup';

import ForgotPasswordPopup from './ForgotPasswordPopup';

export const useForgotPasswordPopup = (onLogged?: () => void) => {
  const { showPopup } = usePopup();

  const showForgotPasswordPopup = () => showPopup(<ForgotPasswordPopup onLogged={onLogged} />);

  return { showForgotPasswordPopup };
};
